'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

define(['app'], function (app) {
  return function (_ref) {
    var _ref$getChoices = _ref.getChoices,
        getChoices = _ref$getChoices === undefined ? function () {
      return [];
    } : _ref$getChoices,
        _ref$initialValue = _ref.initialValue,
        initialValue = _ref$initialValue === undefined ? function () {
      return '';
    } : _ref$initialValue,
        renderDropdownList = _ref.renderDropdownList;

    // % in javascript is remainder, -1 % 5 would return -1, but i want -1 mod 5, i.e. 4
    var mod = function mod(x, y) {
      return (x % y + y) % y;
    };
    var isElementInViewY = function isElementInViewY(element, parent) {
      return parent.scrollTop <= element.offsetTop && element.offsetTop + element.offsetHeight <= parent.scrollTop + parent.offsetHeight;
    };

    var scrollIntoViewOf = function scrollIntoViewOf(element) {
      var scrollableParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$alignBottom = _ref2.alignBottom,
          alignBottom = _ref2$alignBottom === undefined ? false : _ref2$alignBottom;

      if (alignBottom) {
        scrollableParent.scrollTop = element.offsetTop + element.offsetHeight - scrollableParent.offsetHeight;
      } else {
        scrollableParent.scrollTop = element.offsetTop;
      }
    };

    var dropdownInput = function dropdownInput() {
      var comp = {};

      var _selectors = {
        inputDiv: '.dropdownInput'
      };

      var _classes = {
        input: 'dropdownInput_input',
        actual: 'dropdownInput_actual',
        dropdownContainer: 'dropdownInput_dropdown_container',
        dropdown: 'dropdownInput_dropdown',
        dropdownItem: 'dropdownInput_dropdown_item'
      };

      var _attributes = {
        dataClearOnClick: 'data-clear-on-click'
      };

      var _channels = {
        inputSelected: 'dropdownInput/inputSelected',
        refreshChoices: 'dropdownInput/refreshChoices'
      };

      comp.init = function (element) {
        comp.element = element;
        comp.clearOnClick = comp.element.querySelector(_selectors.inputDiv).hasAttribute(_attributes.dataClearOnClick);

        // select all children from _classes
        comp.children = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(_classes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref4 = _slicedToArray(_ref3, 2);

            var key = _ref4[0];
            var cls = _ref4[1];

            comp.children[key] = comp.element.querySelector('.' + cls);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        comp.highlighted = null;

        comp._addListeners();
        comp._initialValue();
        comp.subscribe();
        comp._getChoices().then(function (choices) {
          comp._updateActual(choices);
          comp._renderDropdownListToDOMAndRebind(choices);
        });
        return comp;
      };

      comp.subscribe = function () {
        app.subscribe(_channels.refreshChoices, comp.refreshChoices);
      };

      comp.refreshChoices = function (dropdown) {
        if (dropdown === comp.children.actual.name) {
          comp._getChoices().then(function (choices) {
            comp._updateActual(choices, true);
            comp._renderDropdownListToDOMAndRebind(choices);
          });
        }
      };

      comp.clearDropdown = function () {
        comp.children.input.value = "";
        comp._onInput();
      };
      comp.showDropdown = function () {
        return comp.children.dropdownContainer.setAttribute('data-showed', '');
      };
      comp.hideDropdown = function () {
        return comp.children.dropdownContainer.removeAttribute('data-showed');
      };

      // note: force getChoices to return a promise to allow async getChoices,
      //       e.g. useful if getChoices needs to send ajax requests
      comp._getChoices = function () {
        return Promise.resolve(getChoices(comp.children.input.value, comp));
      };

      comp._initialValue = function () {
        return comp.children.input.value = initialValue(comp);
      };

      comp._getChoiceListItems = function () {
        return comp.children.dropdown.querySelectorAll('.' + _classes.dropdownItem + '-choice');
      };

      comp._addListeners = function () {
        comp.children.input.addEventListener('input', comp._onInput);
        if (comp.clearOnClick) {
          comp.children.input.addEventListener('click', comp.clearDropdown);
        } else {
          comp.children.input.addEventListener('click', comp.showDropdown);
        }
        comp.children.input.addEventListener('focus', comp.showDropdown);
        comp.children.input.addEventListener('blur', comp.hideDropdown);
        comp.children.input.addEventListener('keydown', comp._onKeydown);
      };

      comp._onInput = function () {
        comp._getChoices().then(function (choices) {
          comp._updateActual(choices);
          comp._renderDropdownListToDOMAndRebind(choices);
        });
        comp.showDropdown();
        comp.element.setAttribute('aria-expanded', true);
      };

      comp._updateActual = function (choices, fromRefresh) {
        var choice = choices.find(function (choice) {
          return choice.display !== undefined && comp.children.input.value.toLowerCase() === choice.display.toLowerCase();
        }) || {};
        comp.children.actual.value = choice.value || '';

        if (!fromRefresh) {
          app.publish(_channels.inputSelected, comp.children.actual);
        }
      };

      comp._onKeydown = function (event) {
        switch (event.key) {
          case 'ArrowUp':
            return comp._highlightPrev();
          case 'ArrowDown':
            return comp._highlightNext();
          case 'Enter':
            event.preventDefault();
            return comp._select(comp.highlighted);
          case 'Escape':
            return comp.handleEscapeKeydown(event);
        }
      };

      comp.handleEscapeKeydown = function (event) {
        if (comp.children.dropdownContainer.hasAttribute('data-showed')) {
          event.stopPropagation();
          comp.hideDropdown();
        }
      };

      comp._addListenersForChoices = function () {
        Array.from(comp._getChoiceListItems()).forEach(function (choiceLi, i) {
          choiceLi.addEventListener('mousedown', function (e) {
            return e.preventDefault();
          }); // prevents input's blur from firing
          choiceLi.addEventListener('click', function (e) {
            e.stopPropagation();
            comp._select(i);
          });
        });
      };

      comp._renderDropdownListToDOMAndRebind = function (choices) {
        comp.children.dropdown.innerHTML = comp._renderDropdownList(choices);
        comp._highlight(null);
        comp._addListenersForChoices();
      };

      comp._renderDropdownList = renderDropdownList || function (choices) {
        var inputName = comp.children.actual.getAttribute('name');
        var renderChoiceListItem = function renderChoiceListItem(_ref5, index) {
          var type = _ref5.type,
              display = _ref5.display;

          return '<li id="' + inputName + '-item-' + index + '" role="option" aria-selected="false" class="' + _classes.dropdownItem + ' ' + _classes.dropdownItem + '-' + type + '">' + display + '<div class="item-choice-selected"></div></li>';
        };
        return '<ul id="' + inputName + '-listbox" role="listbox" aria-labelledby="' + inputName + '-label">' + choices.map(renderChoiceListItem).join('') + '</ul>';
      };

      comp._highlight = function (i) {
        var choiceLis = comp._getChoiceListItems();

        if (comp.highlighted in choiceLis) {
          choiceLis[comp.highlighted].removeAttribute('data-highlighted');
        }

        if (i !== null) {
          choiceLis[i].setAttribute('data-highlighted', '');
          comp.children.input.setAttribute("aria-activedescendant", choiceLis[i].id);
        }

        comp.highlighted = i;
      };

      comp._highlightPrev = function () {
        var choicesCount = comp._getChoiceListItems().length;
        var prevIndex = comp.highlighted === null ? choicesCount - 1 : mod(comp.highlighted - 1, choicesCount);
        comp._highlight(prevIndex);
        var prevChoice = comp._getChoiceListItems()[prevIndex];
        if (!isElementInViewY(prevChoice, comp.children.dropdown)) {
          scrollIntoViewOf(prevChoice, comp.children.dropdown);
        }
      };

      comp._highlightNext = function () {
        var nextIndex = comp.highlighted === null ? 0 : mod(comp.highlighted + 1, comp._getChoiceListItems().length);
        comp._highlight(nextIndex);
        var nextChoice = comp._getChoiceListItems()[nextIndex];
        if (!isElementInViewY(nextChoice, comp.children.dropdown)) {
          scrollIntoViewOf(nextChoice, comp.children.dropdown, { alignBottom: true });
        }
      };

      comp._select = function (i) {
        if (i === null) return;
        var choiceLis = comp._getChoiceListItems();
        comp.children.input.value = choiceLis[i].innerText;
        comp._onInput();
        comp.hideDropdown();
        comp.children.input.removeAttribute("aria-activedescendant");
        comp.element.setAttribute("aria-expanded", false);
      };

      return comp;
    };

    return dropdownInput;
  };
});
//# sourceMappingURL=dropdownInputFactory.js.map
